import { render } from "./SelectBox.vue?vue&type=template&id=56a87d97&scoped=true&ts=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"

import "./SelectBox.vue?vue&type=style&index=0&id=56a87d97&scoped=true&lang=css"

import exportComponent from "/home/runner/work/owt/owt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a87d97"]])

export default __exports__